<template>
    <div>
        <text-form-group
                v-model="data.headline"
                name="headline"
                label="Headline"
                :error="(errors.headline || [])[0]"
        />

        <ck-editor-form-group
                v-model="data.content"
                name="content"
                label="Content"
                :error="(errors.content || [])[0]"
        />

        <text-form-group
                v-model="data.link_text"
                name="link_text"
                label="Link Text"
                :error="(errors.link_text || [])[0]"
        />

        <text-form-group
                v-model="data.link_url"
                name="link_url"
                label="Link URL"
                :error="(errors.link_url || [])[0]"
        />

        <gallery-form-group
                v-model="data.image_id"
                name="image_id"
                label="Image"
                :error="(errors.image_id || [])[0]"
        />
    </div>
</template>

<script>
    import CkEditorFormGroup from '@/vendor/forms/FormGroups/Horizontal/CkEditor'
    import GalleryFormGroup from '@/components/FormGroups/Horizontal/Gallery'
    import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

    export default {
        components: {CkEditorFormGroup, GalleryFormGroup, TextFormGroup},

        props: {
            value: {
                required: true
            },

            errors: {
                required: true
            }
        },

        computed: {
            data: {
                get() {
                    return this.value
                },

                set(value) {
                    this.$emit('input', value)
                }
            }
        }
    }
</script>
